import React from "react";
import VorurPage from "@components/Pages/VorurPage/VorurPage";

export default function Software() {
    return <VorurPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
